import React from "react";
import {
  Box,
  FormControl,
  FormHelperText,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ClearIcon from "@mui/icons-material/Clear";

const AppDatePicker = ({
  label,
  id,
  value,
  onChange,
  error,
  onError,
  minDate,
  maxDate,
  disabled = false,
  disableFuture = false,
  disablePast = false,
  required = true,
}) => {
  return (
    <Box sx={{ width: "100%" }}>
      <FormControl fullWidth error={!!error}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={required ? `${label} *` : label}
            value={value}
            onChange={onChange}
            onError={onError}
            format="DD-MMM-YYYY"
            minDate={minDate}
            maxDate={maxDate}
            disabled={disabled}
            disableFuture={disableFuture}
            disablePast={disablePast}
            slots={{
              textField: TextField,
              openPickerIcon: CalendarMonthIcon,
            }}
            slotProps={{
              textField: (params) => ({
                ...params,
                size: "small",

                // ❌ Removed helperText completely
                helperText: "",

                inputProps: {
                  ...params.inputProps,
                  style: { fontSize: "14px" },
                },

                InputProps: {
                  ...params.InputProps,
                  endAdornment: (
                    <InputAdornment position="end">
                      {value && (
                        <IconButton
                          size="small"
                          tabIndex={-1}
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={() => onChange(null)}
                          sx={{ p: 0.2 }}
                        >
                          <ClearIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      )}

                      {/* Calendar icon */}
                      {params.InputProps?.endAdornment}
                    </InputAdornment>
                  ),
                },

                sx: {
                  "& .MuiOutlinedInput-root": {
                    height: "38px",
                    borderRadius: "10px",
                  },

                  // ❌ Hides the space MUI reserves for helper text
                  "& .MuiFormHelperText-root": {
                    display: "none",
                  },
                },
              }),

              openPickerIcon: {
                sx: { fontSize: 18 },
              },
            }}
          />
        </LocalizationProvider>

        {/* Show error ONLY when present */}
        {error && (
          <FormHelperText sx={{ mt: "2px" }}>{error}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default AppDatePicker;
